import { withInstall } from '@bigin/utils'
import Result from './src/result.vue'

export const BResult = withInstall(Result)

export default BResult

export * from './src/result'
